import { GetServerSideProps } from 'next'
import { NextPage } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import Head from 'next/head'

import { VideoDownloader } from '@/components/tools/video-downloader/VideoDownloader'
import { getLocale } from '@/lib/i18n-utils'

type PageProps<TProps extends {}> = {
  pageProps: TProps
}

type VideoDownloaderPageProps = {
  url: string | null
  keyword: string | null
}

export const getServerSideProps: GetServerSideProps<
  VideoDownloaderPageProps
> = async (context) => {
  const locale = await getLocale(context)

  const url = Array.isArray(context.query.url)
    ? context.query.url[0]
    : context.query.url ?? null

  const keyword = Array.isArray(context.query.keyword)
    ? context.query.keyword[0]
    : context.query.keyword ?? null

  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
      url,
      keyword,
    },
  }
}

const VideoDownloaderPage: NextPage<PageProps<VideoDownloaderPageProps>> = ({
  pageProps: { url, keyword },
}) => {
  return (
    <>
      <Head>
        <title>AI STUDIOS - Video Downloader</title>
      </Head>

      <VideoDownloader url={url || undefined} keyword={keyword || undefined} />
    </>
  )
}

export default VideoDownloaderPage
